import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  progressDialog: {
    width: 520,
    height: 400,
  },
  progressBar: {
    height: 15,
    borderRadius: 5,
    backgroundColor: 'rgb(245,245,245)',
  },
  successColor: {
    backgroundColor: 'rgb(0, 213, 146)',
  },
  errorColor: {
    backgroundColor: theme.palette.error.main,
  },
  uploadDialog: {
    width: 450,
    maxHeight: 300,
  },
  overflow: {
    overflow: 'auto',
    maxHeight: 100,
  },
  pauseButton: {
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    },
  },
}));
